module.exports = __webpack_public_path__ + "img/empilhadeiras_pag7.d86c606f.jpg";